import { MapResponseItemsProcessorI, MapState } from 'src/app/interfaces/map.interface';
import { SearchResultAggregation } from 'src/app/swagger-api';
import { SearchResult } from 'src/app/swagger-api/model/searchResult';

export type SharedType<T> = MapResponseItemsProcessorI<T[]>;
export type NonAggregationProcessorType = MapResponseItemsProcessorI<SearchResult[]>;
export type AggregationProcessorType = MapResponseItemsProcessorI<SearchResultAggregation[]>;

export class SharedResponseProcessor<T> implements SharedType<T> {
  public constructor(private originalItems: T[]) {}

  public getProcessedItems(): T[] {
    return this.originalItems;
  }
}

export abstract class SharedResponseProcessorDecorator<T> implements SharedType<T> {
  public constructor(
    protected entity: SharedType<T>,
    protected state: MapState,
  ) {}

  public abstract getProcessedItems(): T[];
}
